import { render, staticRenderFns } from "./SalesJournal.vue?vue&type=template&id=23bb3306"
import script from "./SalesJournal.vue?vue&type=script&lang=js"
export * from "./SalesJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports